import { render } from "./gameDemo.vue?vue&type=template&id=18bc972e&scoped=true"
import script from "./gameDemo.vue?vue&type=script&lang=js"
export * from "./gameDemo.vue?vue&type=script&lang=js"

import "../assets/css/game_wheel.css?vue&type=style&index=0&id=18bc972e&scoped=true&lang=css"
import "./gameDemo.vue?vue&type=style&index=1&id=18bc972e&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18bc972e"]])

export default __exports__